// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Document_cardContainer__AL4W9"};